export function IconLinkedIn() {
  return (
    <path
      fill="currentColor"
      d="M33.75 5H6.25C5.5 5 5 5.5 5 6.25v27.5C5 34.5 5.5 35 6.25 35h27.5c.75 0 1.25-.5 1.25-1.25V6.25C35 5.5 34.5 5 33.75 5ZM13.875 30.625H9.5V16.25H14v14.375h-.125Zm-2.25-16.375C10.25 14.25 9 13.125 9 11.625 9 10.25 10.125 9 11.625 9 13 9 14.25 10.125 14.25 11.625s-1.125 2.625-2.625 2.625Zm19 16.375h-4.5v-7c0-1.625 0-3.75-2.25-3.75-2.375 0-2.625 1.75-2.625 3.625v7.125h-4.5V16.25H21v2c.625-1.125 2-2.25 4.25-2.25 4.5 0 5.375 3 5.375 6.875v7.75Z"
    />
  )
}
